export const insertVariable = (
    source: string,
    valueToInsert: string,
    position: number,
): string => {
    const start = source.slice(0, position);
    const end = source.slice(position);
    return `${start}${valueToInsert}${end}`;
};
export const insertVariableIntoTextarea = (
    input: HTMLInputElement | HTMLTextAreaElement,
    value: string,
): void => {
    const existingValue = input.value || '';
    const cursorPosition = input.selectionStart || 0;
    const cursorPositionAfterInsert = cursorPosition + value.length;
    const newValue = insertVariable(existingValue, value, cursorPosition);
    input.value = newValue;
    input.focus({preventScroll: true});
    input.setSelectionRange(
        cursorPositionAfterInsert,
        cursorPositionAfterInsert,
    );
};
